import { render, staticRenderFns } from "./apprTransfer.vue?vue&type=template&id=7f48a9c4"
import script from "./apprTransfer.vue?vue&type=script&lang=js"
export * from "./apprTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f48a9c4')) {
      api.createRecord('7f48a9c4', component.options)
    } else {
      api.reload('7f48a9c4', component.options)
    }
    module.hot.accept("./apprTransfer.vue?vue&type=template&id=7f48a9c4", function () {
      api.rerender('7f48a9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/appr/apprTransfer.vue"
export default component.exports